import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";
import { get, post } from "./common/http";


export const UpdateStickyHeader = (data: any) => {
  return POST_ENC(`${BASE_URL}/api/StickyHeader/UpdateStickyHeader`, data);
};